import axios from 'axios';

export const basePath = process.env.REACT_APP_BASE_URL;

const Api = axios.create({
  baseURL: basePath,
});

export default Api;
